import { combineReducers } from "redux";
import { oprState } from "./taylorOprReducer";

export const taylorOprReducers = combineReducers({
    oprState: oprState
});
